import styled from "styled-components";

import Button from "core/Button";

import Lock from "core/ReusableIcons/Lock";
import Private from "core/ReusableIcons/Private";

import { BorderBottomLinkStyle } from "core/Typography";
import colors from "core/colors";

import { convertPxToRem } from "frontend/components/helpers";

//ChooseKit:
export const LockButton = styled.button`
    // superficially impose the tooltip button on top of another button:
    position: absolute;
    right: ${convertPxToRem({
        px: 24 + 16
    })}; // 24 = modal padding, 16 = button padding
    top: ${convertPxToRem({
        px: 24 + 16 + 2
    })}; // 24 = modal padding, 16 = button padding, 2 extra positioning

    border: 0;
    padding: 0;
    background: none;
    cursor: pointer;

    ${Lock} {
        width: ${convertPxToRem({ px: 12 })};
        height: ${convertPxToRem({ px: 12 })};
    }
`;

export const KitButton = styled(Button)`
    margin-bottom: ${convertPxToRem({ px: 24 })};

    &:last-of-type {
        margin-bottom: 0;
    }

    ${Private} {
        margin-right: 0;

        &:hover path {
            fill: ${colors.midnight};
        }
    }
`;

//CreateKit:
export const Form = styled.form``;

export const CancelButton = styled.button`
    margin-top: ${convertPxToRem({ px: 16 })};
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    ${BorderBottomLinkStyle}
`;
